export default "__VITE_ASSET__Uf1wpS82__"